export default __webpack_public_path__ + "static/media/remove.505a778d.svg";